import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainHeaderSection = styled.div`
    position: fixed;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 100%;
    height: calc(100vw * (60 / 375));
    // min-height: calc(100vw * (31 / 375));
    // padding: calc(100vw * (12.4 / 375)) calc(100vw * (17 / 375)) calc(100vw * (16.3 / 375));
    background: #fff;
    z-index: 300;    
`;

export const LogoArea = styled.div`
    // width: 100%;
    display: flex;
    align-items: center;
    height: calc(100vw * (31 / 375));
    margin-left: calc(100vw * (17 / 375));
`;

export const HeaderRight = styled.div`
    // width: calc(100vw * (19 / 375));
    // height: calc(100vw * (21 / 375));
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const LogoImage = styled.img`
    width: calc(100vw * (120 / 375));
    height: calc(100vw * (25 / 375));
    margin-right: calc(100vw * (5 / 375));
`;

export const Title = styled.h2`
    font-weight: 700;
    font-size: calc(100vw * (22 / 375));
`

export const ShopLink = styled(Link)`
    position: relative;
    width: calc(100vw * (44 / 375));
    height: calc(100vw * (44 / 375));
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const BellLink = styled(Link)`
    position: relative;
    width: calc(100vw * (44 / 375));
    height: calc(100vw * (44 / 375));
    display: flex;
    justify-content: center;
    align-items: center;

    &:last-child {
        margin-right: calc(100vw * (4 / 375));
    }
`;

export const Alarm = styled.span`
    position: absolute;
    right: calc(100vw * (13 / 375));
    top: calc(100vw * (12 / 375));;
    display: inline-block;
    width: calc(100vw * (9 / 375));
    height: calc(100vw * (9 / 375));
    background-color: #de0000;
    border-radius: 50%;
`;

// export const Spacer = styled.div`
//     height: calc(100vw * (65 / 375)); 
// `;

export const BetaWrapper = styled.span`
    display: inline-block;
    font-family: Arial;
    font-style: italic;
    font-weight: normal;
    font-size: calc(100vw * (12 / 375));
    line-height: calc(100vw * (14 / 375));
    margin-top: calc(100vw * (4 / 375));
    color: #707070;
`

export const IconImg = styled.img`
    width: calc(100vw * (24 / 375));
`